module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_design/simple-58583daa7ecd1e0eeb7feb7bff97b206.png";